import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CaretRight, House } from '@phosphor-icons/react';

const ROUTE_LABELS = {
  dashboard: 'Tableau de bord',
  contacts: 'Contacts',
  organizations: 'Organisations',
  opportunities: 'Opportunites',
  dossiers: 'Dossiers ESS',
  documents: 'GED ESS',
  payments: 'Paiements',
  finance: 'Finances',
  tasks: 'Taches',
  partners: 'Partenaires',
  reporting: 'Reporting',
  settings: 'Parametres',
  users: 'Utilisateurs',
  activity: 'Journal',
  backup: 'Sauvegardes',
  onboarding: 'Onboarding FTPE',
  search: 'Recherche',
  territoires: 'Territoires',
  calendrier: 'Calendrier',
  'impact-ess': 'Impact ESS',
  wallet: 'Wallet & Credits',
  new: 'Nouveau',
};

export function Breadcrumbs() {
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);

  if (segments.length <= 1 && segments[0] === 'dashboard') return null;
  if (segments.length === 0) return null;

  const crumbs = segments.map((seg, idx) => {
    const path = '/' + segments.slice(0, idx + 1).join('/');
    const label = ROUTE_LABELS[seg] || (seg.length > 20 ? seg.slice(0, 8) + '...' : seg);
    const isLast = idx === segments.length - 1;
    return { path, label, isLast };
  });

  return (
    <nav className="flex items-center gap-1.5 text-xs text-[#5E6D66] mb-4" data-testid="breadcrumbs" aria-label="Fil d'Ariane">
      <Link
        to="/dashboard"
        className="flex items-center gap-1 hover:text-[#2D5A4C] transition-colors"
        data-testid="breadcrumb-home"
      >
        <House size={13} weight="fill" />
      </Link>
      {crumbs.map((crumb) => (
        <React.Fragment key={crumb.path}>
          <CaretRight size={10} className="text-[#E8E6E1]" />
          {crumb.isLast ? (
            <span className="font-medium text-[#1A2421]" data-testid="breadcrumb-current">
              {crumb.label}
            </span>
          ) : (
            <Link
              to={crumb.path}
              className="hover:text-[#2D5A4C] transition-colors"
              data-testid={`breadcrumb-${crumb.label}`}
            >
              {crumb.label}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}
